<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'app',
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
.ant-message-custom-content
{
	display: flex;
	align-items: center;
}
body {
    --dsr-main: #4d6bfe;
    --dsr-main-2: rgba(77, 107, 254, .4);
    --dsr-main-3: rgba(77, 107, 254, .2);
    --dsr-bg: rgb(var(--ds-rgb-white));
    --dsr-text-0: rgb(var(--ds-rgb-black));
    --dsr-text-1: rgb(var(--ds-rgb-neutral-800));
    --dsr-text-2: rgb(var(--ds-rgb-neutral-600));
    --dsr-text-3: rgb(var(--ds-rgb-neutral-400));
    --dsr-text-4: rgb(var(--ds-rgb-zinc-350));
    --dsr-border-1: rgb(var(--ds-rgb-neutral-350));
    --dsr-border-2: rgb(var(--ds-rgb-neutral-200));
    --dsr-input-border: #dce0e9;
    --dsr-input-bg: rgb(var(--ds-rgb-gray-100));
    --dsr-button-main-bg: var(--dsr-main);
    --dsr-button-main-bg-hover: #4166d5;
    --dsr-button-second-bg: var(--dsr-main-3);
    --dsr-button-grey-0: rgb(var(--ds-rgb-neutral-150));
    --dsr-button-grey-1: rgb(var(--ds-rgb-neutral-100));
    --dsr-button-grey-2: rgb(var(--ds-rgb-neutral-50));
    --dsr-delete-button-bg: rgb(var(--ds-rgb-red-500) / .85);
    --dsr-delete-button-bg-hover: rgb(var(--ds-rgb-red-550));
    --dsr-tooltip-fg: #eff6ff;
    --dsr-tooltip-bg: rgb(var(--ds-rgb-neutral-850));
    --dsr-side-bg: #f9fbff;
    --dsr-side-hover-bg-rgb: 239, 246, 255;
    --dsr-side-hover-bg: rgb(var(--ds-rgb-blue-50));
    --dsr-icon-fg-1: rgb(var(--ds-rgb-neutral-650));
    --dsr-icon-hover-0: rgb(var(--ds-rgb-neutral-150));
    --dsr-icon-hover-1: rgb(var(--ds-rgb-neutral-100));
    --dsr-side-icon-hover: rgb(var(--ds-rgb-slate-100));
    --dsr-error-fg: rgb(var(--ds-rgb-red-550));
    --dsr-risk-text: #e4773d;
    --dsr-risk-border: rgba(228, 119, 61, .1);
    --dsr-risk-fill: rgba(228, 119, 61, .05);
}
</style>
